import styled from 'styled-components';

import { MEDIA_QUERIES } from "@constants";

export const DEIPageClusterChartLegendDIV = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;

  h3 {
    margin: 0 0 30px;
  }

  p {
    text-align: center;
    margin: 20px 0 0;
    font-size: 14px;
    color: var(--color--charcoal-700);

    ${MEDIA_QUERIES.M} {
      position: absolute;
      bottom: -50px;
      left: 36px;
      margin: 0;
      text-align: left;
    }
  }

  ${MEDIA_QUERIES.M} {
    align-items: flex-start;
  }
`;
